import * as React from 'react';
import { DropdownTabbed } from '../';
import {
    IProperty, IControlType, IAdjustmentChanges, EPropertyTypes, DOMHelper, PropertyHelper, IDropdownOptionDictionary, IConditionConfig,
    EOutputLookupContext
} from '../../helpers';
import { DayPickerStrings, HOURS, MINUTES, VISIBILITY_EXPRESSION_PROPERTY_NAME, PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER } from '../../constants';
import { ContentEditableTinyMCE, QueryBuilder, CheckboxList } from '../';
import { TextField, Toggle, IDropdownOption, DatePicker, Slider } from 'office-ui-fabric-react';

declare var jQuery;

interface IProps {
    componentName: string;
    properties: IProperty[];
    primaryOnly: boolean;
    componentId: string;
    controlType?: IControlType;
    outputOptions?: IDropdownOption[];
    dropdownChange?: (item: any) => void;
    startTabIndex?: number;
    useDefaults?: boolean;
    filteredValueOptions?: IDropdownOptionDictionary;
    propertiesToExclude?: string[];
    change: (Name: string, Value: any, componentId: string) => void;
};

export class PropertiesTitle extends React.Component<IProps, any> {

    private firstUpdate: boolean = true;
    private static multilineDynamicProperties: { [propertyName: string]: boolean } = {
        "Fetch XML": true
    };

    constructor(props: IProps) {
        super(props);
    }

    private inputTimeout;
    private debounceValue = (name: string, value: any, componentId: string) => {

        if (this.inputTimeout) {
            clearTimeout(this.inputTimeout);
        }

        this.inputTimeout = setTimeout(() => {

            this.props.change(name, value, componentId)

        }, PROPERTIES_OUTPUTS_DEBOUNCE_NUMBER);
    }

    private getFormattedDate = (dateString: string): string => {
        let date = new Date(dateString);
        let year = date.getFullYear();
        let month = (1 + date.getMonth()).toString();
        month = month.length > 1 ? month : '0' + month;
        let day = date.getDate().toString();
        day = day.length > 1 ? day : '0' + day;
        return day + '/' + month + '/' + year + ' 00:00:00';
    }

    private extractDate = (dateString: string): Date => {

        let date = new Date();
        //the dateString will be in the format "dd/MM/yyyy hh:mm:ss"
        let splitDate = dateString.split(' ')[0].split('/');
        date.setFullYear(+splitDate[2], +splitDate[1] - 1, +splitDate[0]);
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);

        return date;

    }

    private property = (property: IProperty, index: number): JSX.Element => {

        let field: JSX.Element;
        let { Name, Value, ValueOptions, Default, IsRequired, Min, Max } = property;
        let defaultOption: IDropdownOption[] = [{ text: '-', key: '' }];

        let value = (Value === null || Value === undefined) ? Default : Value;

        let propertyIsDisabled: boolean = this.props.controlType && this.props.useDefaults && PropertyHelper.isDefaultedProperty(this.props.controlType, Name);

        let adjustmentChanges = PropertyHelper.GetAdjustmentChanges(property, value, this.props.properties);

        let tabIndex = this.props.primaryOnly ? null : index + 2;

        if (adjustmentChanges.IsVisible) {
            property.IsInvisible = false;

            switch (property.Type) {

                case EPropertyTypes.string:
                    field = <TextField label={adjustmentChanges.Label || Name} value={value || ''} disabled={propertyIsDisabled}
                        onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
                    break;

                case EPropertyTypes.boolean:
                    field = <Toggle label={adjustmentChanges.Label || Name} checked={value} disabled={propertyIsDisabled}
                        onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
                    break;

                case EPropertyTypes.number:
                    field = <TextField label={adjustmentChanges.Label || Name} value={value.toString()} disabled={propertyIsDisabled}
                        onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
                    break;

                case EPropertyTypes.decimal:
                    field = <TextField label={Name} value={value.toString()} disabled={propertyIsDisabled}
                        onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} required={IsRequired} tabIndex={tabIndex} />;
                    break;

                case EPropertyTypes.dropdown:
                    let options: IDropdownOption[] = defaultOption.concat(adjustmentChanges.OptionValues || ValueOptions);

                    if (this.props.filteredValueOptions && this.props.filteredValueOptions[property.Id]) {
                        let filteredValueOptions = this.props.filteredValueOptions[property.Id];
                        options = options.filter(o => {
                            return o.key === defaultOption[0].key || filteredValueOptions.some(fvo => fvo.key === o.key);
                        });
                    }

                    field = <DropdownTabbed options={options} label={adjustmentChanges.Label || Name} selectedKey={(value || '').toString()} disabled={propertyIsDisabled}
                        required={IsRequired} tabIndex={tabIndex}
                        onChanged={(val) => this.debounceValue(Name, val.key, this.props.componentId)} />;
                    break;

                case EPropertyTypes.dateTime:
                    field = (
                        <div tabIndex={tabIndex}>
                            <DatePicker strings={DayPickerStrings} label={adjustmentChanges.Label || Name} value={value && value.length ? this.extractDate(value) : null} isRequired={IsRequired}
                                onSelectDate={(val) => this.debounceValue(Name, val ? this.getFormattedDate(val.toString()) : null, this.props.componentId)} />
                        </div>
                    );
                    break;

                case EPropertyTypes.listOfOptions:
                    field = null;
                    break;

                case EPropertyTypes.url:
                    field = <TextField label={adjustmentChanges.Label || Name} value={value || ''} required={IsRequired} disabled={propertyIsDisabled}
                        onChanged={(val) => this.debounceValue(Name, val, this.props.componentId)} tabIndex={tabIndex} />;
                    break;

                case EPropertyTypes.input:
                    field = <DropdownTabbed options={ValueOptions} label={adjustmentChanges.Label || Name} selectedKey={value} disabled={propertyIsDisabled}
                        tabIndex={tabIndex} required={IsRequired} onChanged={(val) => this.debounceValue(Name, val.key, this.props.componentId)} />;
                    break;

                case EPropertyTypes.dynamic:

                    field = <ContentEditableTinyMCE
                        label={adjustmentChanges.Label || Name}
                        value={value}
                        outputOptions={this.props.outputOptions || []}
                        singleLine={!PropertiesTitle.multilineDynamicProperties[Name] && !property.IsRichText && !property.IsMultiline}
                        richText={property.IsRichText}
                        onBlur={
                            (val) => this.props.change(Name, val, this.props.componentId)
                        }
                        tabIndex={tabIndex}
                        required={IsRequired}
                        readonly={propertyIsDisabled}
                        outputLookupContext={EOutputLookupContext.NotSpecified}
                    />;

                    break;

                case EPropertyTypes.query:
                    field = <QueryBuilder
                        queryBuilderConfig={value ? JSON.parse(value) : null}
                        label={property.Name}
                        propertyOptions={this.props.outputOptions || []}
                        id={property.Id}
                        outputLookupContext={property.Name === VISIBILITY_EXPRESSION_PROPERTY_NAME ? EOutputLookupContext.VisibilityExpressionConfig : EOutputLookupContext.NotSpecified}
                        onChange={(queryBuilderConfig: IConditionConfig) => {
                            this.debounceValue(Name, JSON.stringify(queryBuilderConfig), this.props.componentId);
                        }}
                    />;
                    break;

                case EPropertyTypes.time:
                    let hours: string = value.split(':')[0];
                    let minutes: string = value.split(':')[1];
                    field = (
                        <div className={IsRequired ? 'required-field' : ''}>
                            <label className="ms-Label">{adjustmentChanges.Label || Name}</label>
                            <div className="ms-Grid">
                                <div className="ms-Grid-row grid-no-padding">
                                    <div className="ms-Grid-col ms-u-sm6">
                                        <DropdownTabbed tabIndex={tabIndex} required={IsRequired} disabled={propertyIsDisabled} options={HOURS} label={'Hours'}
                                            selectedKey={hours} onChanged={(val) => this.debounceValue(Name, val.key + ':' + minutes, this.props.componentId)} />
                                    </div>
                                    <div className="ms-Grid-col ms-u-sm6">
                                        <DropdownTabbed tabIndex={tabIndex} required={IsRequired} disabled={propertyIsDisabled} options={MINUTES} label={'Minutes'}
                                            selectedKey={minutes} onChanged={(val) => this.debounceValue(Name, hours + ':' + val.key, this.props.componentId)} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                    break;

                case EPropertyTypes.wholeNumber:
                    field = (
                        <Slider label={adjustmentChanges.Label || Name} min={Min} max={Max} defaultValue={Default} showValue={true} value={value}
                            disabled={propertyIsDisabled}
                            onChange={(val) => this.debounceValue(Name, val, this.props.componentId)} />
                    );
                    break;

                case EPropertyTypes.checkboxList:
                    field = (
                        <CheckboxList
                            id={property.Id}
                            label={adjustmentChanges.Label || Name}
                            options={ValueOptions}
                            value={value || Default}
                            onChange={(val) => this.props.change(Name, val, this.props.componentId)}
                            required={property.IsRequired}
                        />
                    );
                    break;

            }
        }
        else {
            property.IsInvisible = true;
        }

        let tooltipElement = property.Tooltip && property.Tooltip.length ? <i className="ms-Icon ms-Icon--Info x-hidden-focus property-tooltip"
            title={property.Tooltip} aria-hidden="true" data-toggle="tooltip" data-placement="right" data-html="true">
        </i> : null;

        let item: JSX.Element = field ? field : null;
        return item;

    }

    public componentDidMount() {
        DOMHelper.setDropdownPropertyTabIndex();
        this.firstUpdate = !DOMHelper.focusOnFirstModalTabbableControl();
    }

    public componentDidUpdate() {
        DOMHelper.setDropdownPropertyTabIndex();
        if (!this.props.primaryOnly && this.firstUpdate) {
            this.firstUpdate = !DOMHelper.focusOnFirstModalTabbableControl();
        }
        // move the tooltip to next to the label 
        jQuery('.property-wrapper > .property-tooltip').each((i, elem) => {
            jQuery(elem).closest('.property-wrapper').find('.ms-Label').after(jQuery(elem));
        });
        jQuery('.property-tooltip').tooltip();
    }

    private propertyIsExcluded = (propertyName: string): boolean => {
        return this.props.propertiesToExclude ? this.props.propertiesToExclude.filter(p => p === propertyName).length > 0 : false;
    }

    public render() {

        let { componentName, properties, primaryOnly, propertiesToExclude } = this.props;

        let items: JSX.Element[] = [];
        let filteredProperties: IProperty[];

        if (properties && properties.length) {
            filteredProperties = properties
                .filter(property => !this.propertyIsExcluded(property.Name) && (primaryOnly ? property.IsPrimary : true));

            // items = filteredProperties
            //     .filter(property => !this.propertyIsExcluded(property.Name) && (primaryOnly ? property.IsPrimary : true))
            //     .map(this.property);
        }

        return <span>
            {filteredProperties && filteredProperties[0].Value ? filteredProperties[0].Value : componentName}
        </span>;

    }

}



// WEBPACK FOOTER //
// ./source/ts/components/common/properties-title.tsx